import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/PickUpServiceReport/SearchReport",
    method: "get",
    params
  });
}
export function getArrivalPort(params) {
  return request({
    url: "/PickUpServiceReport/ArrivalPort",
    method: "get",
    params
  });
}
export function getColumns(params) {
  return request({
    url: "/PickUpServiceReport/GetReportHeader",
    method: "get",
    params
  });
}
